/* eslint-disable @typescript-eslint/no-unused-vars */
import { MessageCircle } from 'lucide-react';
import React from 'react';

const SUGGESTED_PROMPTS = [
    "Show me the performance analysis for this quarter",
    "What are the key customer insights from our recent data?",
    "What optimization opportunities do you see in our data?"
];

interface ChatBlankSlateProps {
    onPromptSelect?: (prompt: string) => void;
}

const ChatBlankSlate = ({ onPromptSelect }: ChatBlankSlateProps) => (
    <div>   </div>
);

export default ChatBlankSlate;
